import { getElement } from 'src/utils/parserHTML';
import { parseString } from './parserText';

const FORMATTED_FIELD = ['body', 'snippet', 'title', 'startSnippet'];

export function getEnrichedData(obj, action, getElement, options) {
  const enriched = {};
  const formatted = {};
  const userMap = action.data && action.data.users || {};

  FORMATTED_FIELD
    .filter(field => !!obj[field])
    .forEach(field => enriched[field] = parseString(obj[field], { userMap }, options));

  if (enriched.body) {
    let limit = 140;
    enriched.snippet = JSON.parse(JSON.stringify(enriched.body))
      .filter(item => {
        if (limit < 0) {
          return false;
        }
        switch (item.type) {
          case 'mention':
            limit -= item.username.length;
            return true;
          case 'link':
            const oldLimit = limit;
            limit -= item.text.length;
            return oldLimit < 80 || limit >= -20;
          case 'text':
            const newLimit = limit - item.text.length;
            item.text = item.text.slice(0, limit);
            limit = newLimit;
            return true;
          case 'return':
          default:
            return true;
        }
      });
    if (limit < 0) {
      enriched.snippet.push({ type: 'text', text: '...', style: {} });
    }
  }

  FORMATTED_FIELD
    .filter(field => !!enriched[field])
    .forEach(field => formatted[field] = getElement(enriched[field]));

  return { enriched, formatted };
}

export default function enrichDataObject(obj, mentionedUsers = {}) {
  return Object.assign(obj, getEnrichedData(obj, { data: { users: mentionedUsers } }, getElement));
}
